import { axios } from '@/plugins/axios'
import { IResponseDomain } from '@/api/types'
import { newDomain, IDomain } from '@/models/domain'

export const loadSupportedDomains = async (): Promise<IDomain[]> => {
  const response = await axios.get<IResponseDomain[]>('/domains/')
  return response.data.map((domain) => newDomain(domain))
}
